import db from 'utils/localstorage'

export default {
  namespaced: true,
  state: {
    sidebar: {
      opened: true
    },
    settingBar: {
      opened: false
    },
    isMobile: false,
    theme: db.get('WEB_THEME', 'light'),
    layout: db.get('WEB_LAYOUT', 'side'),
    systemName: '管理系统',
    copyright: `${new Date().getFullYear()} <a style="color:#A9A9A9" href="https://beian.miit.gov.cn" target="_blank">国佳云为（江苏）信息科技有限公司</a>`,
    multipage: getBooleanValue(db.get('WEB_MULTIPAGE'), true),
    fixSiderbar: getBooleanValue(db.get('WEB_FIX_SIDERBAR'), true),
    fixHeader: getBooleanValue(db.get('WEB_FIX_HEADER'), true),
    colorList: [
      'rgb(245, 34, 45)',
      'rgb(250, 84, 28)',
      'rgb(250, 173, 20)',
      'rgb(66, 185, 131)',
      'rgb(82, 196, 26)',
      'rgb(24, 144, 255)',
      'rgb(47, 84, 235)',
      'rgb(114, 46, 209)'
    ],
    color: db.get('WEB_COLOR', 'rgb(24, 144, 255)')
  },
  mutations: {
    setDevice (state, isMobile) {
      state.isMobile = isMobile
    },
    setTheme (state, theme) {
      db.save('WEB_THEME', theme)
      state.theme = theme
    },
    setLayout (state, layout) {
      db.save('WEB_LAYOUT', layout)
      state.layout = layout
    },
    setMultipage (state, multipage) {
      db.save('WEB_MULTIPAGE', multipage)
      state.multipage = multipage
    },
    setSidebar (state, type) {
      state.sidebar.opened = type
    },
    fixSiderbar (state, flag) {
      db.save('WEB_FIX_SIDERBAR', flag)
      state.fixSiderbar = flag
    },
    fixHeader (state, flag) {
      db.save('WEB_FIX_HEADER', flag)
      state.fixHeader = flag
    },
    setSettingBar (state, flag) {
      state.settingBar.opened = flag
    },
    setColor (state, color) {
      db.save('WEB_COLOR', color)
      state.color = color
    }
  }
}

function getBooleanValue (value, defaultValue) {
  if (Object.is(value, null)) {
    return defaultValue
  }
  if (JSON.stringify(value) !== '{}') {
    return value
  } else {
    return false
  }
}
